import { useContext } from "react";
import {
    ACCOUNT_TYPE_NORMAL,
    ACCOUNT_TYPE_TEMPORARY,
    AUTH_APPLICATION_SECURITY,
    PRIVATE_SITE,
    PUBLIC_SITE,
} from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";

const useAccess = () => {
    const { user } = useContext(AuthContext);
    const { whiteLabel, publicSubscriberGroup } = useContext(ApplicationContext);
    const subscriberGroup = whiteLabel?.subscriber_group;
    const isLoggedIn = !!user;
    const isFullyLoggedIn = user?.account_type_id === ACCOUNT_TYPE_NORMAL;
    const isTempUser = user?.account_type_id === ACCOUNT_TYPE_TEMPORARY;
    const isAppSecurityAuth = subscriberGroup?.authentication_type === AUTH_APPLICATION_SECURITY;
    const isPublicSite = publicSubscriberGroup === PUBLIC_SITE;
    const requireLogin = whiteLabel?.require_login === true;
    const isWholesale = publicSubscriberGroup === PRIVATE_SITE && subscriberGroup?.vm_wholesale === true;
    const isGuestExperienceEnabled = subscriberGroup?.enable_guest_experience === true;

    // Require-login eg Family and Friends and wholesale sites (Wholesale VM) both need a full login for anything beyond login/info pages
    const requiresFullLogin = requireLogin || isWholesale;

    // Partial access: browse movies, cinemas, experiences, start a purchase
    const canBrowse = isFullyLoggedIn
        || (!requiresFullLogin && (isPublicSite || (isAppSecurityAuth && isTempUser)));

    // User pages need a full login.
    const canAccessProfile = isFullyLoggedIn && !isGuestExperienceEnabled;

    // Only application security groups can log in/sign
    const canSignInOnSite = isAppSecurityAuth;


    return {
        user,
        isLoggedIn,
        isFullyLoggedIn,
        isTempUser,
        isAppSecurityAuth,
        isPublicSite,
        requireLogin,
        requiresFullLogin,
        isWholesale,
        isGuestExperienceEnabled,
        canBrowse,
        canAccessProfile,
        canSignInOnSite,
    };
};

export default useAccess;
